<script>
export default {
  props: {
    emailAddress: Object,
    message: Object,
    contact: Object,
    brand: Object,
    emailMessageSettings: Array,
  },

  data() {
    return {
      showBody: false,
      isHighlight: false,
    };
  },

  computed: {
    /**
     * @return {Object}
     */
    emailMessage() {
      return _.get(this.message, 'email_message');
    },

    /**
     * @return {String}
     */
    getSubject() {
      const subject = _.get(this.emailMessage, 'subject');

      return _.isEmpty(subject) || _.isNull(subject)
          ? `(without topic)`
          : subject;
    },

    /**
     * @return {String}
     */
    getPreviewUrl() {
      return _.get(this.emailMessage, 'previewUrl');
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    onShowBody() {
      this.showBody = !this.showBody;
    },

    /**
     * @param {Object|null} date
     * @return {String|null}
     */
    formatTime(date) {
      return date
          ? moment(date.iso).format('ddd, MMM D, YYYY ') + date.time
          : null;
    },
  },

}
</script>
